import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getVehicleImages,
  transferVehicleImages,
  updateVehicleImage,
  deleteVehicleImage,
  getVehicleImagesBrands,
} from '../../lib/vehicleImages';

export const fetchVehicleImages = createAsyncThunk(
  'vehicleImages/fetchVehicleImages',
  async ({ vehicleId, options = {} }) => {
    const data = await getVehicleImages(vehicleId, options);
    return data;
  }
);

export const fetchVehicleImagesBrands = createAsyncThunk(
  'vehicleImages/fetchVehicleImagesBrands',
  async ({ vehicleId, options = {} }) => {
    const data = await getVehicleImagesBrands(vehicleId, options);
    return data;
  }
);

export const uploadVehicleImage = createAsyncThunk(
  'vehicleImages/addVehicle',
  async ({ vehicleId, body }, { rejectWithValue }) => {
    try {
      const data = await transferVehicleImages(vehicleId, body);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const editVehicleImage = createAsyncThunk(
  'vehicleImages/updateVehicle',
  async ({ vehicleId, imageId, body }, { rejectWithValue }) => {
    try {
      const data = await updateVehicleImage(vehicleId, imageId, body);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const removeVehicleImage = createAsyncThunk(
  'vehicleImages/deleteVehicleImage',
  async ({ vehicleId, imageId }) => {
    await deleteVehicleImage(vehicleId, imageId);
    return imageId;
  }
);

export const removeVehicleImages = createAsyncThunk(
  'vehicleImages/deleteVehicleImages',
  async (vehicleId) => {
    await deleteVehicleImage(vehicleId);
    return vehicleId;
  }
);
